import { render, staticRenderFns } from "./mustRead.vue?vue&type=template&id=024c4286&scoped=true"
import script from "./mustRead.vue?vue&type=script&lang=js"
export * from "./mustRead.vue?vue&type=script&lang=js"
import style0 from "./mustRead.vue?vue&type=style&index=0&id=024c4286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c4286",
  null
  
)

export default component.exports